import GlobalVariables from '../../../actions/utilAction';
import { loginActionTypes } from './../constants/ApiConstants';

const initialState = {
  loaderBusinessToken: true,
  businessNameCheck: false,
  businessCheckMessage: null,
  access_token: null,
  authenticating: false,
  errorMessage: null,
  errorMessageForInvalidPass: null,
  successMessage: null,
  loginUserInfo: null,
  authenticatingToken: false,
  userLocationList: [],
  loading: false,
  loginResponse: null,
  updateLoginPasswordResponse: null,
  isForcedLogout: false,
  // get_login_questions: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case loginActionTypes.check_business_name.REQUEST:
    return {
      ...state,
      loaderBusinessToken: true,
      businessNameCheck: true,
      businessCheckMessage: null,
      successMessage: null,
      errorMessage: null,
      loading: true
    };
  case loginActionTypes.check_business_name.SUCCESS:
    return {
      ...state,
      loaderBusinessToken: false,
      loading: false,
      businessNameCheck: payload.access_token,
      businessCheckMessage: payload.businessCheckMessage,
      organizationDetails: payload.organizationDetails,
    };
  case loginActionTypes.post_login.REQUEST:
  case loginActionTypes.get_login_questions.REQUEST:
    return {
      ...state,
      authenticating: true,
      loginResponse: null,
      successMessage: null,
      errorMessage: null,
    };
  case loginActionTypes.post_login.SUCCESS:
    if (payload.isOnlyForAgency === true) {
      let pageSize = GlobalVariables.PageSize;
      payload.appConfigurations.filter((data) => {
        if (data.key === 'PAGE_SIZE') {
          pageSize = data.value;
        }
        return pageSize;
      });
      GlobalVariables.PageSize = pageSize;
    }
    return {
      ...state,
      authenticating: false,
      errorMessage: payload.errorMessage,
      access_token: payload.access_token,
      loginUserInfo: payload.loginUserInfo,
      currentLocationId: payload.currentLocationId,
      userPermission: payload.userPermission,
      appConfigurations: payload.isOnlyForAgency === true ? payload.appConfigurations : [],
      userLocationList: payload.isOnlyForAgency === true ? payload.userLocationList : [],
      loginResponse: payload.response,
      isForcedLogout: (typeof payload == "boolean" && payload) ? payload: false
    };
  case loginActionTypes.post_login.FAILURE:
    return {
      ...state,
      authenticating: false,
      authenticatingToken: false,
      errorMessage: payload.errorMessage,
      access_token: payload.access_token,
      loginUserInfo: payload.loginUserInfo,
      loginResponse: null,
    };
  case loginActionTypes.refresh_token.REQUEST:
    return {
      ...state,
      authenticatingToken: true,
    };
  case loginActionTypes.forced_logout_user.SUCCESS:
    return {
      ...state,
      authenticating: false,
      authenticatingToken: false,
      errorMessage: null,
      access_token: null,
      loginUserInfo: null,
    };
  case loginActionTypes.post_forgotPassword.REQUEST:
  case loginActionTypes.post_resetPassword.REQUEST:
    return {
      ...state,
      authenticating: true,
      successMessage: null,
      errorMessage: null,
    };
  case loginActionTypes.post_forgotPassword.FAILURE:
  case loginActionTypes.post_resetPassword.FAILURE:
    return {
      ...state,
      authenticating: false,
      errorMessage: payload.errorMessage,
    };
  case loginActionTypes.post_forgotPassword.SUCCESS:
  case loginActionTypes.post_resetPassword.SUCCESS:
    return {
      ...state,
      authenticating: false,
      successMessage: payload.successMessage,
    };
  case loginActionTypes.get_user_Assigned_locations.REQUEST:
  case loginActionTypes.forced_logout_user.REQUEST:
    return {
      ...state,
      loading: true,
      isForcedLogout: (typeof payload == "boolean" && payload) ? payload: false
    };
  case loginActionTypes.get_user_Assigned_locations.SUCCESS:
    // console.log('data.....payload  Assigned Location........',payload)
    return {
      ...state,
      loading: false,
      userLocationList: payload.data || [],
    };
  case loginActionTypes.update_loginUserPassword.REQUEST:
    return {
      ...state,
      authenticating: true,
      successMessage: null,
      errorMessage: null,
      updateLoginPasswordResponse: null,
    };
  case loginActionTypes.update_loginUserPassword.SUCCESS:
    return {
      ...state,
      authenticating: false,
      successMessage: payload.successMessage,
      errorMessage: payload.errorMessage,
      updateLoginPasswordResponse: payload.response,
    };
  case loginActionTypes.get_resetPasswordLinkIsValid.REQUEST:
    return {
      ...state,
      loading: true,
      errorMessageForInvalidPass: null,
    };
  case loginActionTypes.get_resetPasswordLinkIsValid.SUCCESS:
    const { message, statusCode } = payload;

    let resMessage = (message && statusCode == 401) ? message : null;
    return {
      ...state,
      loading: false,

      errorMessageForInvalidPass: resMessage,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/logins/reducers/LoginReducer.js